export default __webpack_public_path__ + "static/1192-c885a99bc2b7b566d21115a4f3254b60.gif";